import axios from 'cccisd-axios';

// We have to run axios requests from iframe.
// To do that we'll add axios interceptors which will communicate between wordpress and iframe
(() => {
    // We are using error to pass data from axios request interceptor to the response one
    class WordpressLaravelError extends Error {
        constructor(data) {
            super('Wordpress laravel error');
            this.name = 'WordpressLaravelError';
            this.wordpressLaravelData = data;
        }
    }

    const isIframe = window.top !== window.self;

    if (isIframe) {
        window.addEventListener(
            'message',
            async event => {
                if (event.data && event.data.source === 'wordpress-laravel-axios') {
                    const { id, method, url, data } = event.data.payload;
                    const result = await axios({ method, url, data });
                    window.parent.postMessage(
                        {
                            source: 'wordpress-laravel-axios',
                            id,
                            payload: result.data,
                        },
                        '*'
                    );
                }
            },
            false
        );
    }

    let count = 0;

    axios.interceptors.request.use(async config => {
        if (isIframe || !document.getElementById('wordpress-laravel-iframe')) {
            return config;
        }

        const result = await new Promise((resolve, reject) => {
            const iframe = document.getElementById('wordpress-laravel-iframe').contentWindow;
            const id = count++;
            iframe.postMessage(
                {
                    source: 'wordpress-laravel-axios',
                    payload: {
                        id,
                        url: config.url,
                        method: config.method,
                        data: config.data,
                    },
                },
                '*'
            );

            function messageHandler(event) {
                if (
                    event.data &&
                    event.data.source === 'wordpress-laravel-axios' &&
                    event.data.id === id
                ) {
                    window.removeEventListener('message', messageHandler);
                    resolve(event.data.payload);
                }
            }

            window.addEventListener('message', messageHandler, false);
        });

        throw new WordpressLaravelError(result);
    });

    axios.interceptors.response.use(
        res => res,
        err => {
            if (err.wordpressLaravelData) {
                return Promise.resolve(err.wordpressLaravelData);
            }

            throw err;
        }
    );
})();

// Set up public path for webpack
(() => {
    // Getting the entry script path
    const scripts = document.getElementsByTagName('script');
    let entryScriptFolder;
    for (let i = 0; i < scripts.length; i++) {
        const src = scripts[i].src;
        if (/wordpress.{10,50}\.bundle\.js$/.test(src)) {
            entryScriptFolder = src.substr(0, src.lastIndexOf('/') + 1);
            break;
        }
    }

    if (!entryScriptFolder) {
        console.error('Cannot get information about the wordpress entry script');
        return;
    }

    // eslint-disable-next-line camelcase, no-undef
    __webpack_public_path__ = entryScriptFolder;
})();
